import React from "react";

import { TYPES_INDEX_MEDIA } from "../../../constants/fast";
import { AD_BREAK, TIMESLOT } from "../../../constants/media";
import AdBreakMediaIcon from "../../common/icons/AdBreakMediaIcon";
import HostedMediaIcon from "../../common/icons/HostedMediaIcon";
import LiveMediaIcon from "../../common/icons/LiveMediaIcon";
import TimeslotMediaIcon from "../../common/icons/TimeslotMediaIcon";

import type { JSX } from "react";

import type { MediaItem } from "./MediaLibraryItemList";

interface MediaIconProps {
  mediaType?: MediaItem["type"];
  hasCuepoints?: boolean;
}

export default function MediaIcon({
  mediaType,
  hasCuepoints,
}: MediaIconProps): JSX.Element | null {
  switch (mediaType) {
    case TYPES_INDEX_MEDIA.HOSTED: {
      return (
        <HostedMediaIcon
          className="flex shrink-0"
          hasCuepoints={hasCuepoints}
        />
      );
    }
    case TYPES_INDEX_MEDIA.LIVE:
      return <LiveMediaIcon className="flex shrink-0" />;
    case AD_BREAK:
      return <AdBreakMediaIcon className="flex shrink-0" />;
    case TIMESLOT:
      return <TimeslotMediaIcon className="flex shrink-0" />;
    default:
      return <div className="size-[40px]" />;
  }
}
